export var Checkout;
(function (Checkout) {
    /**
     * Load checkout data
     */
    let Load;
    (function (Load) {
        Load.path = 'checkout/load';
    })(Load = Checkout.Load || (Checkout.Load = {}));
    /**
     * Login while on checkout
     */
    let Login;
    (function (Login) {
        Login.path = 'checkout/login';
    })(Login = Checkout.Login || (Checkout.Login = {}));
    /**
     * Logout whiel on checkout
     */
    let Logout;
    (function (Logout) {
        Logout.path = 'checkout/logout';
    })(Logout = Checkout.Logout || (Checkout.Logout = {}));
    /**
     * Save billing address
     */
    let SaveBillingAddress;
    (function (SaveBillingAddress) {
        SaveBillingAddress.path = 'checkout/saveBillingAddress';
    })(SaveBillingAddress = Checkout.SaveBillingAddress || (Checkout.SaveBillingAddress = {}));
    /**
     * Save custom part of data
     */
    let SaveCustom;
    (function (SaveCustom) {
        SaveCustom.path = 'checkout/saveCustom';
    })(SaveCustom = Checkout.SaveCustom || (Checkout.SaveCustom = {}));
    /**
     * Save email
     */
    let SaveEmail;
    (function (SaveEmail) {
        SaveEmail.path = 'checkout/saveEmail';
    })(SaveEmail = Checkout.SaveEmail || (Checkout.SaveEmail = {}));
    /**
     * Save payment data
     */
    let SavePayment;
    (function (SavePayment) {
        SavePayment.path = 'checkout/savePayment';
    })(SavePayment = Checkout.SavePayment || (Checkout.SavePayment = {}));
    /**
     * Save shipping address
     */
    let SaveShippingAddress;
    (function (SaveShippingAddress) {
        SaveShippingAddress.path = 'checkout/saveShippingAddress';
    })(SaveShippingAddress = Checkout.SaveShippingAddress || (Checkout.SaveShippingAddress = {}));
    /**
     * Save shipping method
     */
    let SaveShippingMethod;
    (function (SaveShippingMethod) {
        SaveShippingMethod.path = 'checkout/saveShippingMethod';
    })(SaveShippingMethod = Checkout.SaveShippingMethod || (Checkout.SaveShippingMethod = {}));
    /**
     * Submit checkout
     */
    let Submit;
    (function (Submit) {
        Submit.path = 'checkout/submit';
    })(Submit = Checkout.Submit || (Checkout.Submit = {}));
    /**
     * Load checkout success page data
     */
    let Success;
    (function (Success) {
        Success.path = 'checkout/success';
    })(Success = Checkout.Success || (Checkout.Success = {}));
    /**
     * Capture payment after its been authorised
     * happens after returning from payment gateway
     */
    let PaymentCapture;
    (function (PaymentCapture) {
        PaymentCapture.path = 'checkout/paymentCapture';
    })(PaymentCapture = Checkout.PaymentCapture || (Checkout.PaymentCapture = {}));
    /**
     * Cancel payment after it failed or client cancelled
     * happens after returning from payment gateway
     */
    let PaymentCancel;
    (function (PaymentCancel) {
        PaymentCancel.path = 'checkout/paymentCancel';
    })(PaymentCancel = Checkout.PaymentCancel || (Checkout.PaymentCancel = {}));
})(Checkout || (Checkout = {}));
